import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { type Notification } from "@/Modules/App/Models/Domain/Notification";

import { setPromoCode } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function setPromoCodeAH(userUuid: string, code: string): Promise<Notification | null> {
  const userStore = useUserStore();

  try {
    userStore.notification = null;
    userStore.isLoading = true;

    await setPromoCode(userUuid, code);

    userStore.notification = {
      type: NotificationType.SUCCESS,
      code: null,
      message: "settings.subscription.patient.promo_code.errors.code_apply",
    };
  } catch (error: unknown) {
    const code = isApiError(error) ? error["error_code"] : null;

    switch (code) {
      case ApiErrorCodes.HAS_PROMO_CODE:
        userStore.notification = {
          type: NotificationType.ERROR,
          message: "settings.subscription.patient.promo_code.errors.promo_code_exist",
          code: null,
        };
        break;
      case ApiErrorCodes.INVALID:
      case ApiErrorCodes.INVALID_CODE:
      case ApiErrorCodes.CODE_NOT_FOUND:
      default:
        userStore.notification = {
          type: NotificationType.ERROR,
          message: "settings.subscription.patient.promo_code.errors.code_used",
          code: null,
        };
        break;
    }
  } finally {
    userStore.isLoading = false;
  }

  return userStore.notification;
}

export default setPromoCodeAH;
